import React from 'react'
import ReduxProvider from './redux-provider'
import { Location } from '@reach/router'
import { QueryParamProvider } from 'use-query-params'
import { useAnalytics } from '@chordcommerce/react-autonomy'
import { useEffect } from 'react'

const PageTracker = ({ location }) => {
  const { chordAnalytics } = useAnalytics()

  useEffect(() => {
    const id = setTimeout(() => {
      chordAnalytics?.page()
    }, 50)

    return () => clearTimeout(id)
  }, [chordAnalytics, location])

  return null
}

const WrapWithAllProviders = ({ element }, pluginOptions) => {
  return (
    <ReduxProvider options={pluginOptions}>
      <Location>
        {({ location }) => (
          <>
            <PageTracker location={location} />
            <QueryParamProvider location={location}>
              {element}
            </QueryParamProvider>
          </>
        )}
      </Location>
    </ReduxProvider>
  )
}

export default WrapWithAllProviders
